import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const MinimizeIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\uf1cf'}</MuiIcon>
    );
}
